import React, { useEffect, Suspense, lazy } from "react";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router";

const EndorsementList = lazy(() => import("./endorsements/List"));
const TVSettingsList = lazy(() => import("./settings"));
const CourseList = lazy(() => import("./courses"));

const tviSettingsTabs = [
  {
    label: "Endorsement",
    id: "1",
    key: "endorsements",
    url: "/settings/tesda/endorsements",
    content: <EndorsementList />,
  },
  {
    label: "TVI",
    id: "2",
    key: "tvi",
    url: "/settings/tesda/tvi",
    content: <TVSettingsList />,
  },
  {
    label: "Courses",
    id: "3",
    key: "courses",
    url: "/settings/tesda/courses",
    content: <CourseList />,
  },
];

const Wrapper = styled.div`
  margin-top: 50px;
`;

const HeaderSection = styled(Col)`
  @media (max-width: 575.98px) {
    padding-left: 1rem;
    padding-right: 1rem;

    .header {
      height: 100%;
    }

    .main {
      margin-top: 3rem !important;
    }

    .header-text {
      display: flex;
      justify-content: center;
    }
  }

  @media (min-width: 576px) and (max-width: 1024.98px) {
    padding-left: 5rem;
    padding-right: 5rem;
  }
`;

const StyleTabs = styled(Nav)`
  justify-content: space-between;

  li {
    margin-bottom: 0;
    margin-top: 6px;
    margin-left: 0;
    margin-right: 0;
    cursor: pointer;

    a {
      color: black;
      font-weight: 500;

      &.active {
        font-weight: 600;
        background: ${({ theme }) => theme.colors.buttonBlue} !important;
        color: white !important;
      }

      :hover {
        border-color: transparent !important;
      }
    }
  }
`;

const TabsContainer = styled.div`
  display: flex;
`;

const Main = () => {
  const [activeTab, setActiveTab] = React.useState("1");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const tab = tviSettingsTabs.find((t) => location.pathname.includes(t.key));

    if (tab) {
      setActiveTab(tab.id);
    }
  }, [location]);

  return (
    <Wrapper>
      <Col className="container">
        <HeaderSection>
          <StyleTabs tabs>
            <TabsContainer>
              {tviSettingsTabs.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink
                    className={activeTab === tab.id ? "active" : ""}
                    onClick={() => {
                      navigate(tab.url);
                    }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </TabsContainer>
          </StyleTabs>

          <TabContent activeTab={activeTab}>
            {tviSettingsTabs.map((tabContent) => (
              <TabPane
                key={tabContent.id}
                tabId={tabContent.id}
              >
                <Suspense fallback={<Spinner />}>{tabContent.content}</Suspense>
              </TabPane>
            ))}
          </TabContent>
        </HeaderSection>
      </Col>
    </Wrapper>
  );
};

export default Main;
